import * as React from 'react';
import { StyledDivContentContainer, StyledInstructions } from './WhiteLabelMobileSpeechBox.style';
export const WhiteLabelMobileSpeechBox = ({ speechBoxRichText, speechBoxBackgroundColor }) => {
    //This method use to return html text and dangerouslySetInnerHTML property is use to convert html to plain text
    function displaySpeechBoxText() {
        return {
            __html: speechBoxRichText
        };
    }
    return (React.createElement(StyledDivContentContainer, { speechBubbleBackgroundColor: speechBoxBackgroundColor },
        React.createElement(StyledInstructions, { id: "whiteLabelMobileSpeechBox_text", dangerouslySetInnerHTML: displaySpeechBoxText() })));
};
//# sourceMappingURL=WhiteLabelMobileSpeechBox.js.map